/**
 * @requires ./frc.js
 */

frc.modules.messagingModal = function($module) {
	// Promo Bar
	const $msgModal = $('#messaging-modal');
    if (sessionStorage.getItem('hide-messaging-modal') === null) {
		// $msgModal.show();

		console.log('showing in 1500 ' + window.location.pathname);
		if(window.location.pathname != '/menus/') {
			transitionTimeout = setTimeout(function() {
				$msgModal.fadeIn();
			}, 1500);
		}
		else {
			console.log('skipping modal');
		}
		

        $('#messaging-modal-close').click(function () {
            $msgModal.hide();
            sessionStorage.setItem('hide-messaging-modal', true);
        });
	}
}